import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "dropdownClassName", "disabled"];
import I18n from 'I18n';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { Image } from 'foundations-components/transitional/components/Image';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'styled-components';
import { textButtonStyles, toolbarI18nKey } from '../../constants/toolbar';
import MarginInput from '../MarginInput';
// @ts-expect-error Not typed
import StyleProtectedUIDropdown from '../style-protected/StyleProtectedUIDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderMarginInput = (marginType, value, onChange) => {
  const handleChange = evt => {
    const {
      value: updatedValue
    } = evt.target;
    onChange({
      [marginType]: updatedValue
    });
  };
  return /*#__PURE__*/_jsx(MarginInput, {
    value: value,
    onChange: handleChange
  });
};
const renderMarginContent = props => {
  const {
    margin,
    marginIconType,
    onMarginChange,
    staticPrefix
  } = props;
  const handleMarginChange = updatedMargin => {
    onMarginChange(Object.assign({}, margin, updatedMargin));
  };
  return /*#__PURE__*/_jsxs(Fieldset, {
    "data-test-id": "margin-control-content",
    _size: "small",
    marginBlockStart: "100",
    padding: "300",
    children: [/*#__PURE__*/_jsx(TFlex, {
      direction: "row",
      justify: "center",
      children: renderMarginInput('top', margin.top, handleMarginChange)
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      align: "center",
      justify: "center",
      children: [renderMarginInput('left', margin.left, handleMarginChange), /*#__PURE__*/_jsx(Image, {
        blockSize: "40px",
        inlineSize: "40px",
        margin: "200",
        responsive: false,
        src: `${staticPrefix}/images/${marginIconType}-icon.svg`
      }), renderMarginInput('right', margin.right, handleMarginChange)]
    }), /*#__PURE__*/_jsx(TFlex, {
      direction: "row",
      justify: "center",
      marginBlockEnd: "200",
      children: renderMarginInput('bottom', margin.bottom, handleMarginChange)
    })]
  });
};
function MarginControlButton(props) {
  const {
      className,
      dropdownClassName,
      disabled
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(StyleProtectedUIDropdown, {
    "data-test-id": "margin-control-button",
    use: "unstyled",
    buttonText: I18n.text(toolbarI18nKey('margin')),
    buttonUse: "transparent",
    buttonClassName: className,
    autoPlacement: "horiz",
    placement: "bottom right",
    closeOnMenuClick: false,
    dropdownClassName: dropdownClassName,
    animateOnToggle: false,
    disabled: disabled,
    arrowSize: "medium",
    children: renderMarginContent(rest)
  });
}
MarginControlButton.displayName = 'MarginControlButton';
const StyledMarginControlButton = styled(MarginControlButton).withConfig({
  displayName: "MarginControlButton__StyledMarginControlButton",
  componentId: "sc-10tieo2-0"
})(["", ""], textButtonStyles);
export default StyledMarginControlButton;